import { z } from 'zod'
import { formItemSchema } from './form-item'

export const dateRangeSchema = formItemSchema
  .extend({
    type: z.literal('date-range'),
    allowEmpty: z.tuple([z.boolean(), z.boolean()]).optional().describe('是否允许为空'),
    showTime: z.boolean().optional().describe('是否显示时间选择器'),
    utc: z.boolean().optional().describe('是否使用UTC时间'),
  })
  .describe('日期范围选择器。该组件的值为数组类型，需要自己做映射。')

export type DateRangeSchema = z.infer<typeof dateRangeSchema>
